











 














const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddIntegrationProviderMutation_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "provider",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webhookUrl",
              "storageKey": null
            }
          ],
          "type": "IntegrationProviderWebhook",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serverBaseUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "clientId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tenantId",
              "storageKey": null
            }
          ],
          "type": "IntegrationProviderOAuth2",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AddIntegrationProviderSuccess",
  "abstractKey": null
};

(node ).hash = "031252e1785dd0e14113d8c7801d1f0c";

export default node;
